import { render } from "./HeaderMain.vue?vue&type=template&id=53585ab8&scoped=true"
import script from "./HeaderMain.vue?vue&type=script&lang=js"
export * from "./HeaderMain.vue?vue&type=script&lang=js"

import "./HeaderMain.vue?vue&type=style&index=0&id=53585ab8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53585ab8"]])

export default __exports__